var React = require('react');

function PauseBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM7.5 4.8C7.5 4.63431 7.36569 4.5 7.2 4.5H5.3C5.13431 4.5 5 4.63432 5 4.8V13.2C5 13.3657 5.13431 13.5 5.3 13.5H7.2C7.36569 13.5 7.5 13.3657 7.5 13.2V4.8ZM13 4.8C13 4.63431 12.8657 4.5 12.7 4.5H10.8C10.6343 4.5 10.5 4.63432 10.5 4.8V13.2C10.5 13.3657 10.6343 13.5 10.8 13.5H12.7C12.8657 13.5 13 13.3657 13 13.2V4.8Z","fill":"black"}));
}

PauseBrands.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = PauseBrands;

PauseBrands.default = PauseBrands;
